export default {
  mockupMeta(length) {
    return { pagination: { total: length } };
  },
};
